export enum CmLicensePermissions {
    Console = 'Console',
    Workbench = 'Workbench',
    DeviceConnections = 'Device Connections',
    CommandAdmin = 'Command Administration',
}
